import { required, email, sameAs, minLength, maxLength, not } from 'vuelidate/lib/validators'
import { hasSpecialCharacter, hasLowercase, hasUppercase, hasNumeric, passesApiValidation } from '@/plugins/vuelidate/validators'

export const validations = {
  user: {
    email: {
      required,
      maxLength: maxLength(100),
      email,
      passesApiValidation: passesApiValidation('email')
    },
    first_name: {
      required,
      maxLength: maxLength(100),
      passesApiValidation: passesApiValidation('first_name')
    },
    last_name: {
      required,
      maxLength: maxLength(100),
      passesApiValidation: passesApiValidation('last_name')
    }
  },
  current_password: {
    required,
    passesApiValidation: passesApiValidation('current_password')
  },  
  password: {
    required,
    minLength: minLength(12),
    maxLength: maxLength(100),
    hasLowercase,
    hasUppercase,
    hasNumeric,
    hasSpecialCharacter,
    notSameAs: not(sameAs('current_password')),
    passesApiValidation: passesApiValidation('password')
  },
  password_confirmation: {
    required,
    minLength: minLength(12),
    maxLength: maxLength(100),
    hasLowercase,
    hasUppercase,
    hasNumeric,
    hasSpecialCharacter,
    notSameAs: not(sameAs('current_password')),
    sameAs: sameAs('password'),
    passesApiValidation: passesApiValidation('password_confirmation')
  },
  selectedSubsidiaryIds: {
    minLength: minLength(1),
  }
}

export const messages = {
  user: {
    email: {
      required: 'Required',
      maxLength: 'This field can\'t be more than 100 characters long',
      email: 'Must be a valid email address',
    },
    first_name: {
      required: 'Required',
      maxLength: 'This field can\'t be more than 100 characters long',
    },
    last_name: {
      required: 'Required',
      maxLength: 'This field can\'t be more than 100 characters long',
    }
  },
  current_password: {
    required: 'Required',
  },
  password: {
    required: 'Required',
    minLength: 'Must be at least 12 characters long',
    maxLength: 'Can\'t be more than 100 characters long',
    hasLowercase: 'Must contain a lowercase character',
    hasUppercase: 'Must contain an uppercase character',
    hasNumeric: 'Must contain a numeric character',
    hasSpecialCharacter: 'Must contain a special character',
    notSameAs: 'Must be different from current password',
  },
  password_confirmation: {
    required: 'Required',
    minLength: 'Must be at least 12 characters long',
    maxLength: 'Can\'t be more than 100 characters long',
    hasLowercase: 'Must contain a lowercase character',
    hasUppercase: 'Must contain an uppercase character',
    hasNumeric: 'Must contain a numeric character',
    hasSpecialCharacter: 'Must contain a special character',
    notSameAs: 'Must be different from current password',
    sameAs: 'Must match new password'
  },
  selectedSubsidiaryIds: {
    minLength: 'Must choose at least one subsidiary',
  }
}
